<template>
    <v-app class="quiz-root">
        <!-- Barra estilo WhatsApp -->
        <v-app-bar app color="#128C7E" :height="$vuetify.breakpoint.smAndUp ? 90 : 60" dark flat>
            <img
                src="@/assets/images/whataspp-desktop.svg"
                width="140"
                class="ml-4"
            />
            <v-spacer></v-spacer>
        </v-app-bar>

        <!-- Conteúdo -->
        <v-container
            fluid
            class="d-flex align-center justify-center"
            style="min-height: 100vh; background: #f0f4f9;"
        >
            <v-card
                class="d-flex flex-column justify-center align-center"
                style="height: 100%; width: 900px; background: white;"
                elevation="0"
                light
            >
                <!-- Logo ZaperMenu -->
                <div v-if="step === 0" class="text-center" style="max-width: 460px;">
                    <v-avatar size="120" class="mb-4">
                        <img src="@/assets/images/zapermenu-profile.png" alt="ZaperMenu" />
                    </v-avatar>
                    <h2>
                        ZaperMenu
                        <v-icon color="green">mdi-check-decagram</v-icon>
                    </h2>

                    <div v-if="indicadoPor" class="retorno-selo mt-3">
                        <v-icon small color="#128C7E" class="mr-1">mdi-gift-outline</v-icon>
                        Indicação de {{ indicadoPor }}
                    </div>

                    <!-- Lead que já concluiu o quiz em outra visita -->
                    <template v-if="jaEnviou">
                        <div class="retorno-selo mt-3">
                            <v-icon small color="#128C7E" class="mr-1">mdi-check-circle</v-icon>
                            Você já falou com a gente em {{ dataDoEnvio }}
                        </div>
                        <p class="mt-3">
                            {{ primeiroNomeSalvo ? primeiroNomeSalvo + ', s' : 'S' }}eus dados já estão
                            com o nosso time 🙌<br />
                            É só continuar a conversa por onde paramos.
                        </p>
                        <v-btn
                            color="#128C7E"
                            dark
                            rounded
                            x-large
                            class="mt-4 pulse-button"
                            @click="abrirWhatsappSemNovoLead"
                        >
                            <v-icon left>mdi-whatsapp</v-icon>
                            Abrir a conversa
                        </v-btn>
                        <div>
                            <v-btn text small color="grey darken-1" class="mt-3 text-none" @click="atualizarInformacoes">
                                <v-icon small class="mr-1">mdi-pencil</v-icon>
                                Atualizar minhas informações
                            </v-btn>
                        </div>
                    </template>

                    <!-- Lead que parou no meio em outra visita -->
                    <template v-else-if="temProgressoSalvo">
                        <div class="retorno-selo mt-3">
                            <v-icon small color="#128C7E" class="mr-1">mdi-content-save-check</v-icon>
                            Progresso salvo
                        </div>
                        <p class="mt-3">
                            Que bom te ver de novo{{ primeiroNomeSalvo ? ', ' + primeiroNomeSalvo : '' }}! 👋<br />
                            Você já tinha começado — quer continuar de onde parou?
                        </p>
                        <v-btn
                            color="#128C7E"
                            dark
                            rounded
                            x-large
                            class="mt-4 pulse-button"
                            @click="continuarDeOndeParei"
                        >
                            Continuar de onde parei
                        </v-btn>
                        <div>
                            <v-btn text small color="grey darken-1" class="mt-3 text-none" @click="recomecarDoZero">
                                <v-icon small class="mr-1">mdi-restart</v-icon>
                                Recomeçar do início
                            </v-btn>
                        </div>
                    </template>

                    <!-- Primeira visita -->
                    <template v-else>
                        <p v-if="isTablet" class="mt-2">
                            👋 Olá! Sou o assistente do ZaperMenu.<br />
                            Vamos entender seu salão pra montar o autoatendimento no tablet do seu jeito 🚀
                        </p>
                        <p v-else class="mt-2">
                            👋 Olá! Sou o assistente do ZaperMenu.<br />
                            Vamos entender um pouquinho sobre o seu negócio pra te ajudar da melhor forma 🚀
                        </p>
                        <p class="mt-2 caption">
                            Toque no botão abaixo para começar
                        </p>
                        <v-btn
                            color="#128C7E"
                            dark
                            rounded
                            x-large
                            class="mt-4 pulse-button"
                            @click="nextQuestion"
                        >
                            Começar
                        </v-btn>
                    </template>
                </div>

                <!-- Etapas -->
                <transition :name="transitionName" mode="out-in">
                    <v-card
                        v-if="currentQuestion && step > 0 && step <= visibleQuestions.length"
                        :key="currentQuestion.id"
                        class="pa-6"
                        width="500"
                        elevation="2"
                    >
                        <div class="text-left">
                            <div class="text-caption grey--text mb-2">
                                Etapa {{ step }} de {{ visibleQuestions.length }}
                            </div>
                            <h3 class="mb-2">{{ currentQuestion.title }}</h3>
                            <p v-if="currentQuestion.description" class="grey--text text--darken-1">
                                {{ currentQuestion.description }}
                            </p>
                        </div>

                        <div class="mt-4 text-left">
                            <!-- Única escolha -->
                            <div v-if="currentQuestion.type === 'single'">
                                <v-btn-toggle
                                    v-model="answers[currentQuestion.id]"
                                    class="flex-wrap"
                                    style="max-height: 350px; overflow-x: auto;"
                                >
                                    <v-btn
                                        v-for="opt in currentQuestion.options"
                                        :key="opt"
                                        :value="opt"
                                        outlined
                                        color="#128C7E"
                                        class="ma-1 text-none"
                                        style="border: 1px solid;"
                                        @click="selectSingleOption(opt)"
                                    >
                                        {{ opt }}
                                    </v-btn>
                                </v-btn-toggle>

                                <v-text-field
                                    v-if="currentQuestion.id === 'ramo' && answers.ramo === 'Outros'"
                                    v-model="answers.ramo_outro"
                                    placeholder="Qual é o seu ramo?"
                                    outlined
                                    dense
                                    hide-details
                                    class="mt-3"
                                />
                            </div>

                            <!-- Múltipla escolha -->
                            <div v-else-if="currentQuestion.type === 'multiple'">
                                <v-checkbox
                                    v-for="opt in currentQuestion.options"
                                    :key="opt"
                                    v-model="answers[currentQuestion.id]"
                                    :label="opt"
                                    :value="opt"
                                    multiple
                                    dense
                                    hide-details
                                />
                            </div>

                            <!-- Texto curto -->
                            <v-text-field
                                v-else-if="currentQuestion.type === 'text'"
                                v-model="answers[currentQuestion.id]"
                                :placeholder="currentQuestion.placeholder"
                                outlined
                                dense
                                hide-details
                                class="mt-3"
                            />

                            <!-- Telefone -->
                            <v-text-field
                                v-else-if="currentQuestion.type === 'tel'"
                                v-model="answers[currentQuestion.id]"
                                v-mask="['(##) ####-####', '(##) #####-####']"
                                :placeholder="currentQuestion.placeholder"
                                outlined
                                dense
                                type="tel"
                                hide-details
                                class="mt-3"
                            />

                            <!-- Data de inauguração -->
                            <div v-else-if="currentQuestion.type === 'inauguration_date'">
                                <v-select
                                    v-model="answers[currentQuestion.id]"
                                    :items="inaugurationDateOptions"
                                    item-text="text"
                                    item-value="value"
                                    :placeholder="currentQuestion.placeholder"
                                    outlined
                                    dense
                                    hide-details
                                    class="mt-3"
                                    @change="handleInaugurationDateChange"
                                />

                                <v-checkbox
                                    v-model="answers.inauguracao_sem_data"
                                    label="Ainda não tenho uma data definida"
                                    class="mt-2"
                                    hide-details
                                    @change="handleNoInaugurationDateChange"
                                />
                            </div>

                            <!-- Texto longo -->
                            <div v-else-if="currentQuestion.type === 'textarea'">
                                <v-textarea
                                    v-model="answers[currentQuestion.id]"
                                    :placeholder="currentQuestion.placeholder"
                                    outlined
                                    auto-grow
                                    rows="4"
                                    hide-details="auto"
                                    class="mt-3"
                                />
                                <div class="text-caption mt-1 grey--text">
                                    Mínimo de {{ currentQuestion.minLength || 20 }} caracteres
                                    <span v-if="answers[currentQuestion.id]">
                                        • {{ answers[currentQuestion.id].trim().length }} caracteres
                                    </span>
                                </div>
                            </div>

                            <!-- Plano de interesse -->
                            <div v-else-if="currentQuestion.type === 'plan_picker'" class="plan-picker mt-2">
                                <div class="plan-picker-grid">
                                    <div
                                        v-for="plan in currentQuestion.plans"
                                        :key="plan.id"
                                        class="pp-card"
                                        :class="{
                                            'pp-card--selected': answers[currentQuestion.id] === plan.id,
                                            'pp-card--featured': plan.featured,
                                        }"
                                        @click="$set(answers, currentQuestion.id, plan.id)"
                                    >
                                        <div v-if="plan.featured" class="pp-badge">
                                            <v-icon x-small color="white" class="mr-1">mdi-fire</v-icon>Mais vendido
                                        </div>
                                        <div class="pp-name">{{ plan.label }}</div>
                                        <div class="pp-price">
                                            <span class="pp-amount">{{ plan.price }}</span>
                                            <span class="pp-period">{{ plan.period }}</span>
                                        </div>
                                        <ul class="pp-highlights">
                                            <li v-for="h in plan.highlights" :key="h" class="pp-hl-item">
                                                <v-icon x-small color="#23cf65" class="mr-1">mdi-check-circle</v-icon>{{ h }}
                                            </li>
                                        </ul>
                                        <button class="pp-detail-btn" @click.stop="openPlanDetails(plan)">
                                            Ver todos os recursos <v-icon x-small>mdi-chevron-right</v-icon>
                                        </button>
                                    </div>
                                </div>

                                <!-- <button
                                    class="pp-undecided"
                                    :class="{ 'pp-undecided--selected': answers[currentQuestion.id] === 'nao_decidi' }"
                                    @click="$set(answers, currentQuestion.id, 'nao_decidi')"
                                >
                                    <v-icon small class="mr-2" :color="answers[currentQuestion.id] === 'nao_decidi' ? '#128C7E' : '#9e9e9e'">mdi-help-circle-outline</v-icon>
                                    Ainda não decidi
                                </button> -->
                            </div>
                        </div>

                        <v-progress-linear
                            :value="progress"
                            color="#128C7E"
                            height="6"
                            rounded
                            class="my-5"
                        />

                        <v-row dense>
                            <v-col cols="6">
                                <v-btn
                                    v-if="step > 1"
                                    outlined
                                    color="#128C7E"
                                    rounded
                                    large
                                    block
                                    @click="prevQuestion"
                                >
                                    Voltar
                                </v-btn>
                            </v-col>

                            <v-col cols="6">
                                <v-btn
                                    color="#128C7E"
                                    class="white--text"
                                    rounded
                                    large
                                    block
                                    @click="nextQuestion"
                                    :disabled="!isAnswered"
                                >
                                    {{ isLastStep ? 'Finalizar' : 'Próxima' }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>

                    <!-- Tela final -->
                    <v-card
                        v-else-if="step > visibleQuestions.length"
                        key="finish"
                        width="500"
                        class="pa-6 text-center"
                        elevation="2"
                    >
                        <v-icon color="#128C7E" size="60">mdi-whatsapp</v-icon>
                        <h3 class="mt-3">
                            Perfeito, {{ answers.nome?.split(' ')[0] || 'amigo' }}!
                        </h3>
                        <p class="mt-2">
                            Estamos abrindo o WhatsApp para continuar o atendimento 🚀
                        </p>
                        <v-progress-circular indeterminate color="#128C7E" size="40" class="my-4" />
                    </v-card>
                </transition>
            </v-card>
        </v-container>

        <!-- Dialog: detalhes do plano -->
        <v-dialog v-model="planDetailsDialog" max-width="420" scrollable>
            <v-card v-if="selectedPlanDetails" light>
                <div class="pa-4 pb-3">
                    <div style="font-size:16px;font-weight:700;color:#1a1a1a;margin-bottom:6px;">
                        {{ selectedPlanDetails.label }}
                    </div>
                    <div>
                        <span style="font-size:28px;font-weight:800;color:#1a1a1a;line-height:1;">{{ selectedPlanDetails.price }}</span>
                        <span style="color:#888;font-size:14px;margin-left:3px;">{{ selectedPlanDetails.period }}</span>
                    </div>
                </div>
                <v-divider />
                <v-card-text class="pt-4" style="max-height:360px;">
                    <ul style="list-style:none;padding:0;margin:0;">
                        <li
                            v-for="f in selectedPlanDetails.features"
                            :key="f"
                            style="display:flex;align-items:center;gap:10px;padding:8px 0;font-size:14px;color:#333;border-bottom:1px solid #f0f0f0;"
                        >
                            <v-icon small color="#23cf65">mdi-check-circle</v-icon>
                            {{ f }}
                        </li>
                    </ul>
                </v-card-text>
                <v-divider />
                <v-card-actions class="flex-column pa-4 gap-2">
                    <v-btn
                        color="#128C7E"
                        dark
                        rounded
                        block
                        class="mb-2"
                        @click="selectPlanFromDetails(selectedPlanDetails)"
                    >
                        Tenho interesse neste plano!
                    </v-btn>
                    <v-btn text block small @click="planDetailsDialog = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
import { mapState } from 'vuex';
import { trackEvent, trackLeadMeta } from '@/utils/track';
import { uuidDaResposta } from '@/utils/api';
import { urlConversaWhatsapp } from '@/utils/conversaWhatsapp';
import { registrar as registrarAtribuicao, cookiesMeta } from '@/utils/attribution';
import { VERSAO_QUIZ_WHATSAPP } from '@/store';
import {
  trackQuizInicio,
  trackQuizResposta,
  trackQuizCompleto,
  trackLeadCriado,
  trackClick,
} from '@/utils/lpTracker';

/** Respostas salvas mais antigas que isso são descartadas em vez de restauradas. */
const VALIDADE_QUIZ_DIAS = 90;

/**
 * Campos que acompanham uma resposta mas não são o `id` de uma pergunta —
 * precisam ser salvos e restaurados junto, senão voltam em branco.
 */
const CAMPOS_SATELITE = ['ramo_outro', 'inauguracao_sem_data'];

export default {
    data: () => ({
        step: 0,
        indicadoPor: null,
        direction: 'next',
        planDetailsDialog: false,
        selectedPlanDetails: null,
        // Lead que já enviou e escolheu revisar: libera o quiz sem apagar o
        // registro do envio anterior, que é o que evita o card duplicado no CRM.
        revisandoEnvio: false,
        answers: {
            inauguracao_sem_data: false,
        },
        questions: [
            {
                id: 'ramo',
                title: 'Qual é o seu ramo?',
                description: 'Selecione o tipo de estabelecimento 🍽️',
                type: 'single',
                required: true,
                options: [
                    'Pizzaria', 'Hamburgueria', 'Restaurante', 'Lanchonete', 'Açaiteria', 'Salgaderia',
                    'Comida Oriental', 'Marmitaria', 'Pub', 'Doceria', 'Frango Assado', 'Pastelaria',
                    'Distribuidora de Bebidas', 'Padaria', 'Cafeteria', 'Sorveteria', 'Outros'
                ],
            },
            {
                id: 'tempo_empresa',
                title: 'Há quanto tempo seu negócio está em funcionamento?',
                description: 'Isso ajuda a gente a te orientar melhor 🙂',
                type: 'single',
                required: true,
                options: [
                    'Ainda não inaugurei',
                    'Menos de 6 meses',
                    'De 6 meses a 1 ano',
                    'De 1 a 3 anos',
                    'Mais de 3 anos',
                ],
            },
            {
                // Só para quem está abrindo ou acabou de abrir: é aí que a
                // experiência anterior é o único sinal que existe sobre o dono.
                // Passado o primeiro semestre, quem responde pelo lead é o
                // próprio negócio — ver Contato::getLeadScoreSql na API.
                id: 'experiencia',
                title: 'Antes deste, você já teve um negócio próprio?',
                description: 'Vale qualquer negócio que já foi seu 💼',
                type: 'single',
                required: true,
                conditional: 'negocio_iniciante',
                options: [
                    'Sim, no ramo de alimentação',
                    'Sim, mas de outro ramo',
                    'Não, mas já trabalhei no ramo',
                    'Não, é meu primeiro negócio',
                ],
            },
            {
                id: 'pedidos',
                title: 'Quantos pedidos recebe em média por dia?',
                type: 'single',
                required: true,
                options: ['1 a 10', '11 a 20', '21 a 30', 'Mais de 30'],
            },

            /* PERGUNTAS CONDICIONAIS DE INAUGURAÇÃO */
            {
                id: 'data_inauguracao',
                title: 'Quando está prevista a inauguração?',
                description: 'Selecione uma data prevista ou marque que ainda não definiu.',
                type: 'inauguration_date',
                required: true,
                placeholder: 'Selecione a data prevista',
                conditional: 'inauguracao',
            },
            {
                id: 'detalhes_inauguracao',
                title: 'Certo! Então nos conte sobre a inauguração.',
                description: 'Se você não der detalhes, nós não vamos entrar em contato! Fale se vai ser delivery, se terá salão, quanto funcionários terá, para quando está prevista a inauguração e qual é a expectativa de faturamento para o primeiro mês. Seja o mais detalhista que puder, caso contrário, sua solicitação pode não ser aceita para prosseguir com o atendimento.',
                type: 'textarea',
                required: true,
                minLength: 20,
                placeholder: 'Sua resposta...',
                conditional: 'inauguracao',
            },

            {
                id: 'faturamento',
                title: 'Qual seu faturamento mensal?',
                type: 'single',
                required: true,
                options: [
                    'Até R$10.000',
                    'De R$10.001 a R$20.000',
                    'De R$20.001 a R$40.000',
                    'Acima de R$40.000',
                ],
            },
            {
                id: 'atendimento',
                description: 'Selecione tudo que se aplica 💡',
                title: 'Qual a forma de atendimento?',
                type: 'multiple',
                required: true,
                options: ['Delivery', 'Retirada no balcão', 'Consumo no local'],
            },
            {
                id: 'desafios',
                title: 'Quais são seus principais desafios hoje?',
                description: 'Selecione tudo que se aplica 💡',
                type: 'multiple',
                required: true,
                options: [
                    'Recebo muitos pedidos ao mesmo tempo no WhatsApp',
                    'Ainda anoto pedidos no papel e caneta',
                    'Estou insatisfeito com meu sistema atual',
                    'Taxas altas do iFood',
                    'Quero ter mais controle financeiro e de estoque',
                    'Quero aumentar as vendas',
                ],
            },
            {
                id: 'uso',
                title: 'Onde pretende usar o sistema?',
                type: 'multiple',
                required: true,
                options: [
                    'Computador/Notebook',
                    'Celular Android',
                    'Tablet Android',
                    'Celular iOS (iPhone)',
                    'Tablet iOS (iPad)',
                ],
            },
            {
                id: 'mesas',
                title: 'Quantas mesas seu salão tem?',
                description: 'Isso ajuda a dimensionar o autoatendimento no tablet 🍽️',
                type: 'single',
                required: true,
                conditional: 'tablet',
                options: ['1 a 5', '6 a 10', '11 a 20', '21 a 50', 'Mais de 50'],
            },
            {
                id: 'impressora',
                title: 'Possui impressora térmica?',
                type: 'single',
                required: true,
                options: ['Sim', 'Não', 'Comprei, estou aguardando chegar'],
            },
            {
                id: 'instagram',
                title: 'Qual é o @ do Instagram do seu negócio?',
                type: 'text',
                required: true,
                placeholder: '@meurestaurante',
            },
            // ── Pergunta "Qual plano te interessa?" ocultada temporariamente ──
            // {
            //     id: 'plano_interesse',
            //     title: 'Qual plano te interessa?',
            //     description: 'Escolha o plano que mais chamou sua atenção — assim nossa conversa no WhatsApp será focada nos benefícios certos para o seu negócio 🎯',
            //     type: 'plan_picker',
            //     required: true,
            //     conditional: 'planos',
            //     plans: [
            //         {
            //             id: 'essencial',
            //             label: 'Plano Essencial',
            //             price: 'R$197',
            //             period: '/mês',
            //             highlights: [
            //                 'Cardápio digital + Gestor de pedidos',
            //                 'PDV, QRCode e App garçom',
            //                 'Robô de atendimento no WhatsApp',
            //                 'Suporte humanizado',
            //             ],
            //             features: [
            //                 'Sistema Completo: Delivery, Balcão, Mesa',
            //                 'Cardápio digital',
            //                 'Gestor de pedidos',
            //                 'Impressão automática',
            //                 'PDV, QRCode',
            //                 'App garçom',
            //                 'Robô de atendimento',
            //                 'Venda sugestiva',
            //                 'Cupons de desconto',
            //                 'Sem taxas e limite de pedidos',
            //                 'Relatórios completos',
            //                 'Acompanhamento personalizado',
            //                 'Suporte via WhatsApp',
            //             ],
            //         },
            //         {
            //             id: 'profissional',
            //             label: 'Plano Profissional',
            //             price: 'R$259',
            //             period: '/mês',
            //             featured: true,
            //             highlights: [
            //                 'Tudo do Plano Essencial',
            //                 'Programa de Fidelidade',
            //                 'Disparos no WhatsApp',
            //                 'Pix automatizado',
            //             ],
            //             features: [
            //                 'Tudo do Plano Essencial',
            //                 'Programa de Fidelidade',
            //                 'Disparos no WhatsApp',
            //                 'Pix automatizado',
            //                 'Controle de caixa',
            //                 'Controle de estoque',
            //                 'Ficha Técnica',
            //                 'Contas a pagar/receber',
            //                 'Monitor de Preparo (KDS)',
            //                 'Roteirizador de entregas',
            //                 'Atendente 24/7 com IA',
            //                 'Suporte prioritário',
            //             ],
            //         },
            //     ],
            // },
            {
                id: 'nome',
                title: 'Qual é o seu nome?',
                type: 'text',
                required: true,
                placeholder: 'Digite seu nome',
            },
            {
                id: 'whatsapp',
                title: 'Qual o seu número de WhatsApp?',
                type: 'tel',
                required: true,
                placeholder: '(99) 99999-9999',
                mask: ['(##) ####-####', '(##) #####-####'],
            },
        ],
    }),

    created() {
        // A rota /tablet não tem query string, então o App.vue — que lê os parâmetros uma
        // única vez no mounted — nunca vê o produto. Quem chega aqui pelo CTA traz o
        // ?produto= na rota, e é daqui que o store é semeado. Passa pelo attribution
        // para PERSISTIR: antes, um F5 no /whatsapp devolvia o quiz genérico.
        if (this.$route.query.produto && !this.$store.state.urlParams.produto) {
            this.$store.commit(
                'aplicarAtribuicao',
                registrarAtribuicao({ produto: this.$route.query.produto }),
            );
        }

        this.restaurarRespostasSalvas();

        // LP de tablet de mesa: já sabemos que é consumo no local. Só semeia se a
        // restauração não trouxe nada — resposta do lead ganha do padrão.
        if (this.isTablet && !this.answers.atendimento) {
            this.$set(this.answers, 'atendimento', ['Consumo no local']);
        }
    },

    computed: {
        ...mapState([
            'plan',
            'showPlanos',
            'quizWhatsapp',
            'urlParams',
        ]),

        /**
         * `?produto=` na URL sempre manda; o store só responde quando a rota está
         * muda. Sem o store, um F5 aqui perdia o fluxo de tablet (e a pergunta de
         * mesas junto), porque os CTAs internos derrubam a query.
         */
        isTablet() {
            const daRota = this.$route.query.produto;
            return (daRota || this.urlParams.produto) === 'tablet';
        },

        /** Respostas salvas de uma visita anterior, já validadas. */
        respostasSalvas() {
            const salvo = this.quizWhatsapp;

            if (!salvo || salvo.versao !== VERSAO_QUIZ_WHATSAPP) return null;
            if (!salvo.salvoEm) return null;
            if ((Date.now() - salvo.salvoEm) > VALIDADE_QUIZ_DIAS * 24 * 60 * 60 * 1000) return null;

            return salvo.respostas && Object.keys(salvo.respostas).length ? salvo.respostas : null;
        },

        temProgressoSalvo() {
            if (!this.respostasSalvas) return false;

            return Object.keys(this.higienizar(this.respostasSalvas)).some((chave) => {
                if (CAMPOS_SATELITE.indexOf(chave) !== -1) return false;
                const valor = this.respostasSalvas[chave];
                return Array.isArray(valor) ? valor.length > 0 : !!valor;
            });
        },

        jaEnviou() {
            if (this.revisandoEnvio) return false;
            return !!(this.quizWhatsapp && this.quizWhatsapp.enviadoEm);
        },

        primeiroNomeSalvo() {
            const nome = this.answers.nome || (this.respostasSalvas && this.respostasSalvas.nome);
            return nome ? String(nome).trim().split(' ')[0] : '';
        },

        dataDoEnvio() {
            if (!this.jaEnviou) return '';

            const d = new Date(this.quizWhatsapp.enviadoEm);
            const dia = String(d.getDate()).padStart(2, '0');
            const mes = String(d.getMonth() + 1).padStart(2, '0');

            return `${dia}/${mes}`;
        },

        quizId() {
            return this.isTablet ? 'tablet' : 'whatsapp';
        },

        getPrice() {
            return this.plan.price;
        },

        transitionName() {
            return this.direction === 'next' ? 'slide-left' : 'slide-right';
        },

        isInauguracaoFlow() {
            return this.answers.tempo_empresa === 'Ainda não inaugurei';
        },

        // Quem está abrindo agora ou abriu há menos de meio ano.
        isNegocioIniciante() {
            return [
                'Ainda não inaugurei',
                'Menos de 6 meses',
            ].includes(this.answers.tempo_empresa);
        },

        visibleQuestions() {
            return this.questions.filter((question) => {
                if (question.id === 'pedidos' && this.isInauguracaoFlow) {
                    return false;
                }

                if (question.id === 'faturamento' && this.isInauguracaoFlow) {
                    return false;
                }

                if (question.conditional === 'inauguracao') {
                    return this.isInauguracaoFlow;
                }

                if (question.conditional === 'negocio_iniciante') {
                    return this.isNegocioIniciante;
                }

                if (question.conditional === 'planos') {
                    return this.showPlanos;
                }

                if (question.conditional === 'tablet') {
                    return this.isTablet;
                }

                return true;
            });
        },

        currentQuestion() {
            return this.visibleQuestions[this.step - 1];
        },

        progress() {
            return (this.step / this.visibleQuestions.length) * 100;
        },

        isLastStep() {
            return this.step === this.visibleQuestions.length;
        },

        inaugurationDateOptions() {
            const options = [];
            const today = new Date();

            for (let i = 0; i <= 90; i++) {
                const date = new Date(today);
                date.setDate(today.getDate() + i);

                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');

                options.push({
                    text: `${day}/${month}/${year}`,
                    value: `${year}-${month}-${day}`,
                });
            }

            return options;
        },

        // A mesma regra serve para habilitar o "Próxima" e para achar onde o lead
        // parou na volta — por isso mora em `respondida()`, e não aqui.
        isAnswered() {
            return this.respondida(this.currentQuestion);
        },
    },

    watch: {
        'urlParams.ref': {
            immediate: true,
            handler(ref) {
                this.carregarIndicador(ref);
            },
        },

        'answers.tempo_empresa'(val) {
            if (val === 'Ainda não inaugurei') {
                this.$set(this.answers, 'pedidos', 'INAUGURACAO');
                this.$set(this.answers, 'faturamento', 'INAUGURACAO');
            } else {
                if (this.answers.pedidos === 'INAUGURACAO') {
                    this.$delete(this.answers, 'pedidos');
                }

                if (this.answers.faturamento === 'INAUGURACAO') {
                    this.$delete(this.answers, 'faturamento');
                }

                this.$delete(this.answers, 'data_inauguracao');
                this.$delete(this.answers, 'detalhes_inauguracao');
                this.$set(this.answers, 'inauguracao_sem_data', false);
            }

            // A pergunta de experiência só existe em certas faixas de tempo. Sem
            // esta limpeza, quem volta e troca o tempo leva a resposta antiga junto.
            if (!this.isNegocioIniciante) {
                this.$delete(this.answers, 'experiencia');
            }

            if (this.step > this.visibleQuestions.length) {
                this.step = this.visibleQuestions.length;
            }
        },
    },

    methods: {
        async carregarIndicador(ref) {
            this.indicadoPor = null;

            if (!ref || !/^\d+$/.test(String(ref))) {
                return;
            }

            try {
                const { data } = await this.$http.get(`indicacao/ref/${ref}`);
                this.indicadoPor = data && data.data ? data.data.fantasia : null;
            } catch (e) {
                // Sem o nome, o quiz segue igual — a indicação vai no envio de qualquer forma.
            }
        },

        /**
         * Descarta valor salvo que não existe mais nas opções atuais da pergunta.
         *
         * Não é opcional: o que é gravado é o RÓTULO (é o que o v-model recebe), e
         * rótulo muda — `mapImpressora` no finish() ainda carrega a forma antiga
         * "Já comprei e estou aguardando chegar" justamente por isso. Sem a
         * higienização, o lead volta, o botão não acende, mas `isAnswered` libera
         * o "Próxima" e ele avança com uma resposta que nunca viu na tela.
         */
        higienizar(respostas) {
            const limpo = {};
            const porId = {};

            this.questions.forEach((q) => { porId[q.id] = q; });

            Object.keys(respostas || {}).forEach((chave) => {
                const valor = respostas[chave];

                if (valor === null || valor === undefined || valor === '') return;

                if (CAMPOS_SATELITE.indexOf(chave) !== -1) {
                    limpo[chave] = valor;
                    return;
                }

                const pergunta = porId[chave];
                if (!pergunta) return;   // pergunta removida do questionário

                if (pergunta.type === 'single') {
                    // 'INAUGURACAO' é sentinela escrita pelo watcher, não é opção de tela.
                    if (pergunta.options.indexOf(valor) === -1 && valor !== 'INAUGURACAO') return;
                    limpo[chave] = valor;
                    return;
                }

                if (pergunta.type === 'multiple') {
                    const validos = Array.isArray(valor)
                        ? valor.filter(v => pergunta.options.indexOf(v) !== -1)
                        : [];
                    if (validos.length) limpo[chave] = validos;
                    return;
                }

                if (pergunta.type === 'plan_picker') {
                    if (!(pergunta.plans || []).some(p => p.id === valor)) return;
                    limpo[chave] = valor;
                    return;
                }

                if (pergunta.type === 'inauguration_date') {
                    // A lista é gerada a partir de hoje: data que já passou não vale mais.
                    if (!this.inaugurationDateOptions.some(o => o.value === valor)) return;
                    limpo[chave] = valor;
                    return;
                }

                limpo[chave] = valor;   // text, tel, textarea
            });

            return limpo;
        },

        restaurarRespostasSalvas() {
            if (!this.respostasSalvas) return;

            const limpo = this.higienizar(this.respostasSalvas);
            if (!Object.keys(limpo).length) return;

            this.answers = { ...this.answers, ...limpo };

            // Mesma limpeza contextual que o watcher de `tempo_empresa` faz na
            // navegação viva: pergunta que não está visível não carrega resposta.
            if (!this.isTablet) this.$delete(this.answers, 'mesas');
            if (!this.isNegocioIniciante) this.$delete(this.answers, 'experiencia');
        },

        /**
         * Persiste o conjunto INTEIRO, não só a pergunta atual: o watcher de
         * `tempo_empresa` escreve sentinelas em `pedidos`/`faturamento`, e
         * `ramo_outro` / `inauguracao_sem_data` não são `id` de pergunta nenhuma.
         */
        persistirRespostas() {
            this.$store.commit('salvarQuizWhatsapp', { ...this.answers });
        },

        respondida(q) {
            if (!q) return false;

            const val = this.answers[q.id];

            if (!q.required) return true;

            if (q.type === 'multiple') {
                return Array.isArray(val) && val.length > 0;
            }

            if (q.type === 'textarea') {
                return !!val && val.trim().length >= (q.minLength || 20);
            }

            if (q.type === 'inauguration_date') {
                return !!this.answers.data_inauguracao || !!this.answers.inauguracao_sem_data;
            }

            if (q.id === 'ramo' && val === 'Outros') {
                return !!(this.answers.ramo_outro && this.answers.ramo_outro.trim().length >= 3);
            }

            return !!val;
        },

        /**
         * Índice (1-based) da primeira pergunta VISÍVEL ainda em branco. Roda sobre
         * `visibleQuestions` e não sobre `questions`: as condicionais dependem das
         * respostas que acabaram de ser restauradas.
         */
        primeiraPerguntaEmBranco() {
            const perguntas = this.visibleQuestions;

            for (let i = 0; i < perguntas.length; i++) {
                if (!this.respondida(perguntas[i])) return i + 1;
            }

            // Tudo respondido: para na última, que é a que envia — o lead revisa
            // e conclui em vez de voltar ao começo.
            return perguntas.length;
        },

        continuarDeOndeParei() {
            trackQuizInicio(this.quizId);
            trackClick('Quiz WhatsApp - continuou de onde parou');

            this.direction = 'next';
            this.$nextTick(() => {
                this.step = this.primeiraPerguntaEmBranco();
            });
        },

        recomecarDoZero() {
            trackClick('Quiz WhatsApp - recomecou do zero');

            this.$store.commit('limparQuizWhatsapp');
            this.answers = { inauguracao_sem_data: false };
            this.revisandoEnvio = false;

            if (this.isTablet) {
                this.$set(this.answers, 'atendimento', ['Consumo no local']);
            }

            trackQuizInicio(this.quizId);
            this.direction = 'next';
            this.step = 1;
        },

        /**
         * Lead que já enviou e só quer voltar à conversa. Não faz POST: é o caminho
         * que evita o reenvio acidental (9,8% dos contatos de 2026 são o mesmo
         * WhatsApp cadastrado de novo, e cada um abre um card novo no CRM).
         */
        abrirWhatsappSemNovoLead() {
            trackClick('Quiz WhatsApp - reabertura sem novo lead');
            this.abrirConversaWhatsapp();

            setTimeout(() => {
                this.$router.push({ path: 'obrigado', query: { name: this.primeiroNomeSalvo } });
            }, 3000);
        },

        /** Lead já enviado que quer corrigir algo: revisa as respostas e reenvia. */
        atualizarInformacoes() {
            trackClick('Quiz WhatsApp - atualizar informacoes');

            this.revisandoEnvio = true;
            trackQuizInicio(this.quizId);
            this.direction = 'next';
            this.step = 1;
        },

        abrirConversaWhatsapp() {
            window.open(urlConversaWhatsapp(this.isTablet ? 'tablet' : null), '_blank');
        },

        openPlanDetails(plan) {
            this.selectedPlanDetails = plan;
            this.planDetailsDialog = true;
        },

        selectPlanFromDetails(plan) {
            this.$set(this.answers, this.currentQuestion.id, plan.id);
            this.planDetailsDialog = false;
        },

        selectSingleOption(opt) {
            this.$set(this.answers, this.currentQuestion.id, opt);

            if (this.currentQuestion.id === 'tempo_empresa') {
                if (opt === 'Ainda não inaugurei') {
                    this.$set(this.answers, 'pedidos', 'INAUGURACAO');
                    // Sentinela própria: 'ATE_10K' era indistinguível de quem respondeu
                    // "Até R$10.000" de verdade e inflava essa faixa nos relatórios.
                    this.$set(this.answers, 'faturamento', 'INAUGURACAO');
                } else {
                    if (this.answers.pedidos === 'INAUGURACAO') {
                        this.$delete(this.answers, 'pedidos');
                    }

                    if (this.answers.faturamento === 'INAUGURACAO') {
                        this.$delete(this.answers, 'faturamento');
                    }
                }
            }

            this.$nextTick(() => {
                if (this.answers[this.currentQuestion.id]) {
                    if (this.currentQuestion.id === 'ramo' && opt === 'Outros') return;
                    this.nextQuestion();
                }
            });
        },

        handleInaugurationDateChange(value) {
            if (!value) return;

            this.$set(this.answers, 'inauguracao_sem_data', false);

            this.$nextTick(() => {
                this.nextQuestion();
            });
        },

        handleNoInaugurationDateChange(value) {
            if (!value) return;

            this.$set(this.answers, 'data_inauguracao', null);

            this.$nextTick(() => {
                this.nextQuestion();
            });
        },

        nextQuestion() {
            this.direction = 'next';

            if (this.step === 0) {
                trackQuizInicio(this.quizId);
                this.step++;
                return;
            }

            if (this.currentQuestion) {
                trackQuizResposta(
                    this.quizId,
                    this.step,
                    this.currentQuestion.title,
                    this.answers[this.currentQuestion.id],
                );

                // Grava agora, não no fim: quem fecha a aba no meio volta de onde parou.
                this.persistirRespostas();
            }

            if (this.isLastStep) {
                return this.finish();
            }

            this.step++;
        },

        prevQuestion() {
            this.direction = 'prev';

            if (this.step > 1) {
                this.step--;
            }
        },

        finish() {
            this.step++;

            const mapRamo = {
                'Pizzaria': 'PIZZARIA',
                'Hamburgueria': 'HAMBURGUERIA',
                'Restaurante': 'RESTAURANTE',
                'Lanchonete': 'LANCHONETE',
                'Açaiteria': 'ACAITERIA',
                'Salgaderia': 'SALGADERIA',
                'Comida Oriental': 'COMIDA_ORIENTAL',
                'Marmitaria': 'MARMITARIA',
                'Pub': 'PUB',
                'Doceria': 'DOCERIA',
                'Frango Assado': 'FRANGO_ASSADO',
                'Pastelaria': 'PASTELARIA',
                'Distribuidora de Bebidas': 'DISTRIBUIDORA_DE_BEBIDAS',
                'Padaria': 'PADARIA',
                'Cafeteria': 'CAFETERIA',
                'Sorveteria': 'SORVETERIA',
                'Outros': 'OUTROS',
            };

            const mapPedidos = {
                'INAUGURACAO': 'INAUGURACAO',
                '1 a 10': 'DEZ',
                '11 a 20': 'VINTE',
                '21 a 30': 'TRINTA',
                'Mais de 30': 'TRINTA_MAIS',
            };

            const mapTempoEmpresa = {
                'Ainda não inaugurei': 'INAUGURACAO',
                'Menos de 6 meses': 'ATE_6_MESES',
                'De 6 meses a 1 ano': 'DE_6M_A_1A',
                'De 1 a 3 anos': 'DE_1A_A_3A',
                'Mais de 3 anos': 'MAIS_3A',
            };

            const mapFaturamento = {
                'INAUGURACAO': 'INAUGURACAO',
                'Até R$10.000': 'ATE_10K',
                'De R$10.001 a R$20.000': 'DE_10K_A_20K',
                'De R$20.001 a R$40.000': 'DE_20K_A_40K',
                'Acima de R$40.000': 'ACIMA_40K',
            };

            const mapExperiencia = {
                'Sim, no ramo de alimentação': 'DONO_ALIMENTACAO',
                'Sim, mas de outro ramo': 'DONO_OUTRO_RAMO',
                'Não, mas já trabalhei no ramo': 'TRABALHOU_RAMO',
                'Não, é meu primeiro negócio': 'PRIMEIRO_NEGOCIO',
            };

            const mapAtendimento = {
                'Delivery': 'DELIVERY',
                'Retirada no balcão': 'BALCAO',
                'Consumo no local': 'MESA',
            };

            const mapUso = {
                'Computador/Notebook': 'COMPUTADOR',
                'Celular Android': 'ANDROID',
                'Tablet Android': 'TABLET',
                'Celular iOS (iPhone)': 'IPHONE',
                'Tablet iOS (iPad)': 'IPAD',
            };

            const mapImpressora = {
                'Sim': 'SIM',
                'Não': 'NAO',
                'Já comprei e estou aguardando chegar': 'AGUARDANDO',
                'Comprei, estou aguardando chegar': 'AGUARDANDO',
            };

            // Pergunta "Qual plano te interessa?" ocultada temporariamente
            // const mapPlanoInteresse = {
            //     'essencial': 'ESSENCIAL',
            //     'profissional': 'PROFISSIONAL',
            //     // 'nao_decidi': 'NAO_DECIDI',
            // };

            const mapDesafios = {
                'Recebo muitos pedidos ao mesmo tempo no WhatsApp': 'PEDIDOS_WHATSAPP',
                'Ainda anoto pedidos no papel e caneta': 'ORGANIZACAO',
                'Estou insatisfeito com meu sistema atual': 'SISTEMA_ATUAL',
                'Taxas altas do iFood': 'TAXAS',
                'Quero ter mais controle financeiro e de estoque': 'CONTROLE',
                'Quero aumentar as vendas': 'FATURAMENTO',
            };

            const mapMesas = {
                '1 a 5': 'ATE_5',
                '6 a 10': 'DE_6_A_10',
                '11 a 20': 'DE_11_A_20',
                '21 a 50': 'DE_21_A_50',
                'Mais de 50': 'ACIMA_50',
            };

            const mapSingle = (val, map) => map[val] || val;
            const mapMultiple = (arr, map) => Array.isArray(arr) ? arr.map(i => map[i] || i) : [];

            const metaCookies = cookiesMeta();

            const data = {
                nome: this.answers.nome,
                whatsapp: '55' + this.answers.whatsapp.replace(/\D/g, ''),
                atendimento: mapMultiple(this.answers.atendimento, mapAtendimento),
                pedidos: mapSingle(this.answers.pedidos, mapPedidos),
                tempo_empresa: mapSingle(this.answers.tempo_empresa, mapTempoEmpresa),
                faturamento: mapSingle(this.answers.faturamento, mapFaturamento),
                experiencia: this.answers.experiencia ? mapSingle(this.answers.experiencia, mapExperiencia) : null,
                ramo: mapSingle(this.answers.ramo, mapRamo),
                ramo_outro: this.answers.ramo === 'Outros' ? (this.answers.ramo_outro || null) : null,
                uso: mapMultiple(this.answers.uso, mapUso),
                desafios: mapMultiple(this.answers.desafios, mapDesafios),
                impressora: mapSingle(this.answers.impressora, mapImpressora),
                instagram: this.answers.instagram,
                data_inauguracao: this.answers.inauguracao_sem_data ? null : this.answers.data_inauguracao,
                inauguracao_sem_data: !!this.answers.inauguracao_sem_data,
                detalhes_inauguracao: this.answers.detalhes_inauguracao || null,
                // Pergunta "Qual plano te interessa?" ocultada temporariamente
                // plano_interesse: mapSingle(this.answers.plano_interesse, mapPlanoInteresse) || null,
                mesas: this.answers.mesas ? mapSingle(this.answers.mesas, mapMesas) : null,
                // Vem do store, não da rota: sobrevive a refresh e à navegação interna.
                // A atribuição é resolvida pelo [src/utils/attribution.js] — pode ter
                // vindo da URL agora ou sido resgatada de uma visita anterior.
                produto: this.urlParams.produto || null,
                anuncio_uuid: this.urlParams.ad,
                origem: this.urlParams.origem || this.urlParams.utm,
                indicacao_empresa_id: this.urlParams.ref || null,

                // Procedência da atribuição. Sem isso, um anúncio resgatado do
                // storage fica indistinguível de um clique de verdade no relatório.
                origem_fonte: this.urlParams.fonte || null,
                origem_primeira: this.urlParams.primeiro ? this.urlParams.primeiro.origem : null,
                anuncio_uuid_primeiro: this.urlParams.primeiro ? this.urlParams.primeiro.ad : null,
                visitante_uuid: this.urlParams.visitante_uuid || null,
                utm_params: this.urlParams.utm_params || null,

                // Conversions API da Meta: cookies do pixel e a página do cadastro.
                meta_fbp: metaCookies.fbp,
                meta_fbc: metaCookies.fbc,
                meta_event_source_url: window.location.href,
            };

            this.$http.post('contato', data).then((res) => {
                const uuid = uuidDaResposta(res);

                if (uuid) {
                    // Mesmo event_id do Lead que o servidor manda (deduplicação da Meta).
                    trackLeadMeta(uuid, { content_name: 'quiz whatsapp' });

                    this.$store.commit('marcarQuizWhatsappEnviado', uuid);

                    // É este evento que liga a sessão ao lead no lp_sessoes — e que
                    // ficou cinco meses sem disparar por uma leitura errada do uuid.
                    trackLeadCriado(uuid);
                    trackQuizCompleto(this.quizId, uuid);
                } else {
                    // Falhar alto: foi exatamente o silêncio daqui que escondeu o bug.
                    console.warn('[quiz] POST /contato sem uuid na resposta', res && res.data);
                    this.$store.commit('marcarQuizWhatsappEnviado', null);
                }
            }).finally(() => {
                trackEvent('AddToCart', 'add_to_cart');
                trackEvent('Contact',   'contact');

                this.abrirConversaWhatsapp();

                const firstName = data.nome?.split(' ')[0] || '';
                setTimeout(() => {
                    this.$router.push({ path: 'obrigado', query: { name: firstName } });
                }, 3000);
            });
        },
    },
};
</script>

<style scoped>
.quiz-root {
    background-color: #f0f4f9;
    font-family: 'Roboto', sans-serif;
}

.retorno-selo {
    display: inline-flex;
    align-items: center;
    background: #e7f5f2;
    color: #0f6e63;
    border: 1px solid #b7e0d8;
    border-radius: 999px;
    padding: 4px 14px;
    font-size: 13px;
    font-weight: 500;
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
    transition: all 0.2s ease;
    position: relative;
}

.slide-left-enter,
.slide-right-leave-to {
    opacity: 0;
    transform: translateX(40px);
}

.slide-left-leave-to,
.slide-right-enter {
    opacity: 0;
    transform: translateX(-40px);
}

.pulse-button {
    position: relative;
    overflow: hidden;
    animation: pulseGlow 2.4s ease-in-out infinite;
    background-color: #128C7E !important;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    box-shadow: 0 0 0 rgba(18, 140, 126, 0.3);
    font-weight: 600;
    letter-spacing: 0.5px;
}

.pulse-button:hover {
    transform: scale(1.07);
    box-shadow: 0 0 20px rgba(18, 140, 126, 0.4);
}

@keyframes pulseGlow {
    0% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(18, 140, 126, 0.45);
    }
    50% {
        transform: scale(1.05);
        box-shadow: 0 0 0 10px rgba(18, 140, 126, 0.0);
    }
    100% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(18, 140, 126, 0);
    }
}

/* ── Plan Picker ── */
.plan-picker-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    margin-bottom: 12px;
}

@media (max-width: 480px) {
    .plan-picker-grid {
        grid-template-columns: 1fr;
    }
}

.pp-card {
    position: relative;
    border: 2px solid #e0e0e0;
    border-radius: 14px;
    padding: 16px 14px 12px;
    cursor: pointer;
    transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
    background: #fafafa;
    display: flex;
    flex-direction: column;
}

.pp-card:hover {
    border-color: #128C7E;
    box-shadow: 0 4px 16px rgba(18, 140, 126, 0.15);
}

.pp-card--selected {
    border-color: #128C7E !important;
    background: rgba(18, 140, 126, 0.05);
    box-shadow: 0 4px 16px rgba(18, 140, 126, 0.2);
}

.pp-card--featured {
    border-color: #f40612;
    padding-top: 22px;
}

.pp-card--featured.pp-card--selected {
    border-color: #f40612 !important;
    background: rgba(244, 6, 18, 0.03);
    box-shadow: 0 4px 16px rgba(244, 6, 18, 0.12);
}

.pp-badge {
    position: absolute;
    top: -13px;
    left: 50%;
    transform: translateX(-50%);
    background: #f40612;
    color: white;
    font-size: 10px;
    font-weight: 700;
    padding: 3px 10px;
    border-radius: 999px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    box-shadow: 0 2px 8px rgba(244, 6, 18, 0.35);
}

.pp-name {
    font-weight: 700;
    font-size: 14px;
    color: #1a1a1a;
    text-align: center;
    margin-bottom: 4px;
}

.pp-price {
    text-align: center;
    margin-bottom: 10px;
}

.pp-amount {
    font-size: 22px;
    font-weight: 800;
    color: #1a1a1a;
}

.pp-period {
    font-size: 12px;
    color: #888;
}

.pp-highlights {
    list-style: none;
    padding: 0;
    margin: 0 0 10px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    flex: 1;
}

.pp-hl-item {
    display: flex;
    align-items: flex-start;
    gap: 4px;
    font-size: 11px;
    color: #444;
    line-height: 1.4;
}

.pp-detail-btn {
    width: 100%;
    font-size: 11px;
    color: #128C7E;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px 0 0;
    text-align: center;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
    border-top: 1px solid #eee;
    margin-top: auto;
    padding-top: 8px;
}

.pp-detail-btn:hover {
    text-decoration: underline;
}

.pp-undecided {
    width: 100%;
    padding: 12px 16px;
    border: 2px dashed #ccc;
    border-radius: 10px;
    background: none;
    cursor: pointer;
    font-size: 14px;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: border-color 0.2s, color 0.2s, background 0.2s;
}

.pp-undecided:hover {
    border-color: #128C7E;
    color: #128C7E;
}

.pp-undecided--selected {
    border-color: #128C7E;
    color: #128C7E;
    background: rgba(18, 140, 126, 0.05);
}

.pulse-button::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.3);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.pulse-button:hover::after {
    opacity: 1;
}
</style>
